export enum AutoFeederRejectReason {
    EXIT = 'Exit',
    FOCUS = 'Focus'
}
